import React, { Component } from 'react';
import withTranslations from '../../utils/HighOrderComponent';
import './Instruction.css';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { downloadInstruction } from '../../actions/instructions';

class Instruction extends Component {
  downloadUserInstruction = () => {
    const messages = this.props.t.NotificationMessages;
    this.props.downloadInstruction(messages);
  };

  render() {
    const { content, instruction, tooltip } = this.props.t || {};
    return (
      <div>
        <div>
          <h3>{instruction}</h3>
        </div>
        <div className="content">
          <p>{content}</p>
          <Link onClick={() => this.downloadUserInstruction()}>
            <Tooltip title={tooltip} placement="top" arrow={true}>
              <AssignmentOutlinedIcon
                fontSize="large"
                style={{ color: '#203a5d' }}
              />
            </Tooltip>
          </Link>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    downloadInstruction: (messages) => dispatch(downloadInstruction(messages)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withTranslations(Instruction, 'Instruction'));
